const MIN_ROWS_TO_SHOW_BREAKER = 4;

const positionBreakerInTable = (tableBody) => {
  if (!tableBody) {
    return;
  }

  const breaker = tableBody.querySelector('.products-table__breaker');
  if (!breaker) {
    return;
  }

  const rows = Array.from(tableBody.children).filter(
    (element) =>
      element.classList.contains('products-table__row') &&
      !element.classList.contains('products-table__breaker'),
  );

  if (rows.length < MIN_ROWS_TO_SHOW_BREAKER) {
    breaker.hidden = true;
    return;
  }

  breaker.hidden = false;

  const middleIndex = Math.ceil(rows.length / 2) - 1;
  rows[middleIndex]?.after(breaker);
};

export const initProductsBreaker = () => {
  const run = () => {
    document
      .querySelectorAll('.products-table__body')
      .forEach((tableBody) => positionBreakerInTable(tableBody));
  };

  run();

  let frameId = null;
  const observer = new MutationObserver(() => {
    if (frameId) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      run();
      frameId = null;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};